/* eslint-disable */
import Slide from './slide'
import Details from './details'
import Video from '../../components/pages/video'
import Services from '../../components/pages/services'
import Events from './events'
import Team from '../../components/pages/team'
import Contact from '../../components/pages/contact'
import Recall from '../../components/pages/recall'

const Home = ({ className }) => {
  return (
    <main className={className}>
      <Slide />
      <Details />
      <Video />
      <Services short={true} />
      <Team />
      <Events />
      <Contact />
      <Recall />
    </main>
  )
}

export default Home
